
import { Component, OnInit, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';

import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Utility } from '../../../common/utility';
import { BaseService } from '../../../shared/services/base.service';
import { FormLabelComponent } from '../../../components/form/label/label.component';
import { FormMessageComponent } from '../../../components/form/message/message.component';
import { AppMessages } from '../../../shared/constants/messages';

import { DiseaseModel } from '../../../models/master-data/diseases.model';
import { DiseasesService } from './diseases.service';
import { DialogService } from '../../../shared/services/dialog.service';

@Component({
    selector: 'modify-disease-popup',
    templateUrl: 'modify-disease-popup.component.html',
    providers: [DiseasesService]
})

export class ModifyDiseasePopupComponent implements OnInit {
    title: string;
    diseaseForm: FormGroup;
    diseaseModel = new DiseaseModel();
    formMessage = '';
    public generalInfoDiseaseMaxLength = 25000;
    public symptomsDiseaseMaxLength = 16000;
    public isSuccess = false;
    public linkedData = [];

    constructor(
        private formBuilder: FormBuilder,
        private baseService: BaseService,
        public dialogService: DialogService,
        public utility: Utility,
        private diseasesService: DiseasesService,
        public dialogRef: MdDialogRef<ModifyDiseasePopupComponent>,
        @Inject(MD_DIALOG_DATA) public data: any) { }

    ngOnInit() {
        this.diseaseModel.id = this.data.id;
        if (this.diseaseModel.id) {
            this.title = 'Update Disease';
            this.getDisease(this.data.id);
        } else {
            this.title = 'Add New Disease';
        }
        this.createForm();
        this.linkedData = this.diseasesService.getLinkedData();
    }

    createForm() {
			let newDisease = new DiseaseModel();
        this.diseaseForm = this.formBuilder.group({
            Name: [newDisease.name, [Validators.required]],
            Vector: newDisease.vector,
            Symptoms: newDisease.symptoms,
            DiseaseMap: newDisease.diseaseMap,
            GeneralInformation: newDisease.generalInformation,
            isHaveVaccine : newDisease.isHaveVaccine
        });
    }

    close() {
        this.dialogRef.close(this.isSuccess);
    }

    addDisease(){
        this.diseasesService.addNewDisease(this.diseaseForm.value).subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.dialogService.openSuccessDialog({ message: data.message });
                    this.isSuccess = true;
                    this.close();
                }
            }
        )
    }

    editDisease(){
      if(this.diseaseForm.controls['isHaveVaccine'].value == '1'){
            this.diseaseForm.controls['isHaveVaccine'].setValue(true);
        }else{
            this.diseaseForm.controls['isHaveVaccine'].setValue(false);
        }
        this.diseasesService.updateDisease(this.data.id, this.diseaseForm.value).subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.dialogService.openSuccessDialog({ message: data.message });
                    this.isSuccess = true;
                    this.close();
                }
            }
        )
    }

    getDisease(id){
        this.diseasesService.getDisease(id).subscribe(
            (result) => {
                const data = result.json();
                this.diseaseModel = data;
                if(this.diseaseModel.isHaveVaccine === false){
                  this.diseaseModel.isHaveVaccine = 0;
                }else{this.diseaseModel.isHaveVaccine = 1;}
                console.log(this.diseaseModel);
            }, (error) => { }
        );
    }

    onSubmit() {
        if (this.diseaseForm.valid) {
            if (this.diseaseModel.id) {
                this.editDisease();
            } else {
                this.addDisease();
            }
        }
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/diseases/modify-disease-popup.component.ts